<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="User" :required="true">
              <b-form-select
                @blur="$v.clerk.user_id.$touch"
                :class="{ 'is-invalid': $v.clerk.user_id.$error }"
                v-model="clerk.user_id"
                :options="users"
                text-field="name"
                value-field="id"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.clerk.user_id.required"
              >
                Please select user
              </div>
            </form-group>

             <form-group label="Branches" :required="true">
              <span v-for="item in branches" :key="item.id">
              <b-form-checkbox
                v-model="clerk.branches"
                :value="item.id"
              >
               {{ item.name }}
              </b-form-checkbox>
              </span>
                <div class="text-danger" v-if="$v.clerk.branches.$error">
                Please select branches
              </div>
            </form-group>

          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import clerkRepo from "@/api/repos/clerkRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },



  validations: {
    clerk: {
      user_id: {
        required,
      },
      branches: {
        required,
      },
    },
  },

  mounted() {
        this.getData();
  },

  data() {
    return {
      clerk: {
        branches:[]
      },
      users: [],
      branches : [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
     async getData() {
      try {
        let { data } = await clerkRepo.createGetData();
        this.users = data.users;
        this.branches = data.branches;
      } catch (error) {
        console.log(error);
      }
    },

    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await clerkRepo.create(this.clerk);
          this.$emit("clerkCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

